"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Permissions = void 0;
const server_sdk_1 = require("@air/server-sdk");
const types_1 = require("@air/types");
const request_1 = require("./request");
const util_1 = require("./util");
/**
 * Returns the permissions that the authenticated account (or short url, if `shortId`
 * is provided) has on the specified `objects`. Can be used in 3 `modes`:
 * - `intersection` (default): returns the permissions that the user has on all of
 *    the specified objects
 * - `union`: returns the permission that the user has an any of the specified
 *    objects
 * - `all`: returns a separate permission set for each of the specified objects
 * @param params
 * @param workspaceId
 * @param shortId
 * @returns
 */
function getFromObjects(args) {
    if ('shortId' in args) {
        const { shortId } = args, body = __rest(args, ["shortId"]);
        return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
            endpoint: `${args.shortId}/permissions/check`,
            method: 'POST',
            body,
            authorized: 'optional',
            shortUrlProtection: { id: args.shortId },
        });
    }
    const { workspaceId } = args, body = __rest(args, ["workspaceId"]);
    return (0, request_1.airRequest)(types_1.EndpointType.permissions, {
        endpoint: 'check',
        method: 'POST',
        body,
        workspaceId: args.workspaceId,
        authorized: 'optional',
    });
}
exports.Permissions = Object.assign({ getFromObjects }, (0, util_1.sdkToApi)(server_sdk_1.Permissions));
//# sourceMappingURL=permissions.js.map